import React, { useState, useCallback } from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/styles';
import { useDispatch } from 'react-redux';

const WideButton = styled(Button)({
  marginTop: 6,
  marginBottom: 6,
  width: '100%',
});

const WideTextField = styled(TextField)({
  marginTop: 6,
  marginBottom: 6,
  width: '100%',
});

export const SetName = ({ survey, finish }) => {
  const [name, setName] = useState(survey.name);
  const dispatch = useDispatch();

  const saveSurvey = () => {
    dispatch({
      type: 'UPDATE_SURVEY',
      payload: {
        survey: {
          ...survey,
          name,
        },
      },
    });
    finish();
  };

  return (
    <Grid container>
      <Grid item xs={12} container>
        <Typography variant="h6">Name The Survey</Typography>
      </Grid>
      <br />
      <br />
      <Grid item xs={12}>
        <WideTextField
          placeholder="Survey Name"
          onChange={(e) => setName(e.target.value)}
          variant="outlined"
          value={name}
        />
        <br />
        <WideButton
          onClick={saveSurvey}
          variant="contained"
          size="large"
          color="primary"
        >
          Save and Close
        </WideButton>
      </Grid>
    </Grid>
  );
};
